import { useState, useEffect, useRef } from 'react';
import { string, array, oneOfType, bool, object } from 'prop-types';
import { HeaderActionsDropdown } from './headerActionsDropdown';

export const HeaderActions = ({
  title,
  subtitle,
  actions = [],
  headerCustomColor,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const dropdownBodyRef = useRef(null);

  const handleOutsideClick = e => {
    const dropdownBody = dropdownBodyRef.current;
    if (dropdownBody && !dropdownBody.contains(e.target)) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  const toggleDropdown = () => {
    if (actions.length !== 0) {
      setDropdownOpen(prevState => !prevState);
    }
  };

  return (
    <div ref={dropdownBodyRef}>
      <HeaderActionsDropdown
        options={actions}
        headerCustomColor={headerCustomColor}
        isActive={dropdownOpen}
        toggleDropdown={toggleDropdown}
        title={title}
        subtitle={subtitle}
      />
    </div>
  );
};

HeaderActions.propTypes = {
  actions: array,
  title: string.isRequired,
  headerCustomColor: object,
  subtitle: oneOfType([string, bool]),
};
